export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13402.d5b21835.jpg";